import React from "react";
import { SelectInput } from "components/form";
import { useStaticCollection } from "utils/hooks";

export default (props) => {
  let collection = useStaticCollection("/selects/main_education_types.json");

  if (props.admissionForm) {
    collection = collection.filter((item) => item.value !== "none" && item.value !== "elementary_school");
  }

  const prefix = props.prefix || {
    id: "main_education_type",
    name: "main_education_type",
  };

  return (
    <div className="form-group">
      <SelectInput
        {...props}
        placeholder="Selecione..."
        name={prefix.name}
        id={prefix.id}
        collection={collection}
        label={props.label || "Qual é o seu nível de escolaridade principal?"}
        helperText="Usaremos isso para sugerir vagas e gerar o contrato de estágio corretamente."
      />
    </div>
  );
}